import { useIdentityStore } from '../lib/store';

export const useCurrentUser = () => {
	return useIdentityStore((state) => state.user);
};
